import { refreshSharingTipsForAttachment } from './satchelV3Actions/publicActions';
import getAttachment from '../selectors/getAttachment';
import { ReferenceAttachmentModel } from '../store/schema/AttachmentModel';
import getOpenUrlForReferenceAttachment from '../utils/getOpenUrlForReferenceAttachment';
import { ClientAttachmentId } from 'owa-client-ids';
import { OwaDate } from 'owa-datetime';
import { isFeatureEnabled } from 'owa-feature-flags';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';

export default action('setAttachmentPermissionLevel')(function setAttachmentPermissionLevel(
    attachmentId: ClientAttachmentId,
    permissionLevel: AttachmentPermissionLevel,
    attachLongPathName?: string,
    expirationDate?: OwaDate
) {
    const refAttachmentModel = getAttachment(attachmentId) as ReferenceAttachmentModel;
    const refAttachment = refAttachmentModel.model as ReferenceAttachment;
    refAttachment.PermissionType = permissionLevel;
    if (attachLongPathName) {
        refAttachment.AttachLongPathName = attachLongPathName;
        refAttachmentModel.openUrl = getOpenUrlForReferenceAttachment(
            refAttachment,
            getUserConfiguration()
        );
    }

    if (
        isFeatureEnabled('doc-attachment-referenceAttachmentExpiration') &&
        refAttachmentModel.info &&
        refAttachmentModel.info.sharingInfo
    ) {
        refAttachmentModel.info.sharingInfo.expirationDate = expirationDate;
    }

    refreshSharingTipsForAttachment(attachmentId);
});
